module.exports = __webpack_public_path__ + "static/img/iconfont.e6cf650.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/iconfont.svg?t=1527744720428
// module id = Mu93
// module chunks = 24